import { CellValue } from './CellValue';
import { UnitValue } from './UnitValue';

export function isUnitValue(value: unknown): value is UnitValue {
    return !!value && Array.isArray(value) && value.length === 2 && value
        .filter((v) => typeof v !== 'string').length === 0;
}

export function isArrayOfUnitValue(value: CellValue): value is UnitValue[] {
    return !!value && Array.isArray(value) && value.filter((v) => isUnitValue(v)).length === value.length;
}
